export const getBounds = (points, maps) => {
    if (maps && points ) {  
        console.log({points})
        const bounds = new maps.LatLngBounds();
        points.forEach((i) => {
            bounds.extend(i);
        })
        return bounds
    }
}